import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/sf-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row border-top border-bottom my-3 align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col my-3 text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"height":"50px","width":"161px"},
      src: _imports_0
    })
  ])
], -1)
const _hoisted_2 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Har du planer på att sälja din bostad eller kanske få en dagsaktuell värdering?"),
  /*#__PURE__*/_createTextVNode(" Vi är en del av Svensk Fastighetsförmedling som har 85 års erfarenhet av bostadsförsäljningar. Om du behöver komma i kontakt med en kompetent och professionell mäklare kan du enkelt göra det nedan så sätter vi upp kontakten. Du kan ändra mäklarkommun eller bostadsadress om du inte vill använda förifyllda uppgifter. ")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "border-top border-light pt-3 mt-3" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Uppgifter om din bostad:", -1)
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-6 mb-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-6 mb-3" }
const _hoisted_14 = { class: "col-sm-6 mb-3" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-6 mb-3" }
const _hoisted_17 = { class: "col-sm-6 mb-3" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-6 mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Jag behöver hjälp med:", -1)
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_24 = {
  key: 1,
  class: "alert alert-secondary"
}
const _hoisted_25 = { class: "mt-3" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-4 d-grid" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfButton = _resolveComponent("SfButton")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (!_ctx.app.hideOutgoingLeadForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, " Vi har bett en mäklare kontakta dig. Om du har frågor eller behöver hjälp kan du chatta med oss under Meddelande. ")),
    (!_ctx.app.hideOutgoingLeadForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyType, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-md-3 col-6 d-grid mb-3"
              }, [
                _createVNode(_component_SfButton, {
                  text: item.text,
                  icon: item.icon,
                  type: item.type,
                  modelValue: _ctx.form.realEstateType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.realEstateType) = $event))
                }, null, 8, ["text", "icon", "type", "modelValue"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_SelectInput, {
                label: "Kommun",
                modelValue: _ctx.officeName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.officeName) = $event)),
                options: _ctx.municipalities,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOfficeName()))
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_TextField, {
                label: "Antal rum (0 - 6+)",
                modelValue: _ctx.form.numberOfRooms,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.numberOfRooms) = $event)),
                required: true,
                numbersOnly: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_TextField, {
                label: "Boarea (kvm 0 - 300+)",
                modelValue: _ctx.form.areaSquareMeter,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.areaSquareMeter) = $event)),
                required: true,
                numbersOnly: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_TextField, {
                label: "Adress",
                modelValue: _ctx.form.address,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.address) = $event)),
                required: true,
                numbersOnly: false
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_TextField, {
                label: "Postnummer",
                modelValue: _ctx.form.postalCode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.postalCode) = $event)),
                required: true,
                numbersOnly: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_TextField, {
                label: "Postort",
                modelValue: _ctx.form.city,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.city) = $event)),
                required: true,
                numbersOnly: false
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadAction, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-md-3 col-6 d-grid mb-3"
              }, [
                _createVNode(_component_SfButton, {
                  text: item.text,
                  type: item.type,
                  modelValue: _ctx.form.leadAction,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.leadAction) = $event))
                }, null, 8, ["text", "type", "modelValue"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.isInValid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.failedAlertText), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isValid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.successAlertText), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  disabled: _ctx.disabledBtn,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sendLead())),
                  class: "btn btn-primary"
                }, " Skicka uppgifter ", 8, _hoisted_28)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}